import { Link } from "react-router-dom";
import {useState, useEffect, useMemo } from "react";
import $ from 'jquery';
import apiClient from "../../http-common";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL,REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";
import { toast } from 'react-toastify';
import DataLoader from "../../Utils/DataLoader";

const AddAttendance = () => {
    const [users, setUsers] = useStateWithCallbackLazy([]);
    const [atten, setAtten] = useStateWithCallbackLazy([]);
    const [currentDate, setCurrentDate] = useState(new Date().toISOString().slice(0,10));
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);
 
    const defaultCheckList = async () => 
    {
        await fetch(HTTPURL+'admin/check-attendance',
        {
            headers: {"Content-Type": "application/JSON"}
        })
        .then(res => res.json())
        .then(data => 
        {
            setAtten([data.data]);
        })
        .catch(err => console.log(err)); 
    }

    async function getAllData()
    {
        try {
            const res = await apiClient.get("/admin/userList/0");
            setUsers(res.data.data, () => {
                setShowResults(true, () => {
                    $('#datatablesSimple').DataTable();
                });
            });
        } catch (err) {
            console.log(err);
        }
    }

    // handle apply btn 
    const handleButton = () => 
    {        
        const formData = {
            'date' : currentDate
        }
        fetch(HTTPURL+'admin/check-attendance-list',
        {
            method: "POST",
            headers: {"Content-Type": "application/JSON"},
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data => 
        {
            if(data.status === true)	
            {	
                setAtten([data.data]);
                toast.success(data.message);	
            }else{	
                toast.error(data.message);	
            }
        })
        .catch(err => console.log(err));
    }

    // handle checked box
    const [demo, setDemo] = useStateWithCallbackLazy({
        id:'',
        status:false
    });
    const handleCheckbox = (user_id,e) => 
    {
        let status = e.target.checked;
        setDemo({
            id:user_id,
            status:status
        });
        const formData = {
            'user_id' : user_id,
            'status' : status,
            'date' : currentDate
        }
        fetch(HTTPURL+'admin/add-attendance',
        {
            method: "POST",
            headers: {"Content-Type": "application/JSON"},
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then((data) => 
        {
            if(data.status === true)
            {
                toast.success(data.message);
            }else{
                toast.error(data.message);
            }
        })
        .catch(err => toast.error(err));
    }

    useEffect(() => {
        getAllData();  
        defaultCheckList();
    },[demo]);

    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Add Attendance</h1>
                <ol className="breadcrumb mb-4">
                    <Link to="/admin/dashboard" className="breadcrumb-item">Dashboard</Link>
                    <Link className="breadcrumb-item active">Add Attendance</Link>
                </ol>

                <div className="card mb-4">
                    <div className="card-header">
                        <i className="fas fa-table me-1"></i>
                        Add Attendances List
                    </div>
                    <div className="card-body">
                        { showResults ? 
                            <>
                                <div className="row">
                                    <div className="col-md-08 text-center">
                                        <input type="date" value={currentDate} id="currentDate" onChange={(e) => setCurrentDate(e.target.value)} />&nbsp;&nbsp;
                                        <input type="button" className="btn btn-success sap-btn-darks" value="Apply" onClick={handleButton}/>
                                    </div>
                                </div>
                                <table id="datatablesSimple">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                
                                    {users.length > 0 && (
                                        <tbody>
                                        {users.map(user => (
                                            <tr key={user.id}>
                                                <td title={user.firstName + ' '+ user.lastName}>
                                                    <img src={user.photo !== null ? HTTPURL+'images/'+user.photo: HTTPURL+'images/default.png'} width='50' height='50' alt={user.photo? user.photo : 'default.png'} />
                                                </td>
                                                <td>{user.firstName + ' '+ user.lastName}</td>
                                                <td>
                                                    <ul className="list-inline m-0">
                                                        <li className="list-inline-item">
                                                            <input class="form-check-input" 
                                                                type="checkbox" 
                                                                name="status"
                                                                onChange={(e)=>handleCheckbox(user.id,e)} 
                                                                checked={ atten[0]?.includes(user.id) ? true : demo.id == user.id && demo.status ? true:false} 
                                                            />
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    )}
                                </table>
                            </>
                        : <DataLoader/> }
                    </div>
                </div>
            </div>
        </main>
    )
};

export default AddAttendance;